// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__hyucK","legacyBtn":"MutateMid_legacyBtn__E6vKj"};